import ResourceAudioPage from "@/components/ResourceAudioPage";
import { GROUNDING_AUDIO_URL } from "@/content";

export default function GroundingPage() {
  return (
    <ResourceAudioPage
      title="Grounded"
      subtitle="A short, gentle guided practice to help you land back in your body and feel the steadiness that's already underneath you — no experience needed."
      label="Grounded · Guided Practice"
      src={GROUNDING_AUDIO_URL}
      testId="grounding-page"
    />
  );
}
